export default __webpack_public_path__ + "static/media/1_Recepcion_Operadores.ff82470c.mp3";